<mat-card>
  <app-card-header
    title="Detalle del Servicio"
    icono="build"
    [draggable]="true"
  ></app-card-header>

  <mat-divider></mat-divider>

  <mat-card-content class="card-content-crear">
    <!-- Datos del Servicio -->
    <app-content-card title="Datos del Servicio" icon="assignment" color="blue">
      <div class="info-grid">
        <div class="info-item">
          <strong>Tipo</strong>
          <span>{{ servicio.tipo || 'Sin tipo' }}</span>
        </div>
        <div class="info-item">
          <strong>{{ vehiculoLabel }}</strong>
          <span>{{ servicio.activo?.identificacion || 'Sin asignar' }}</span>
        </div>
        @if (servicio.subcategoria) {
          <div class="info-item">
            <strong>Subcategoría</strong>
            <span>{{ servicio.subcategoria }}</span>
          </div>
        }
        <div class="info-item">
          <strong>Fecha</strong>
          <span>{{ fechaTexto }}</span>
        </div>
        @if (servicio.cliente) {
          <div class="info-item">
            <strong>Cliente</strong>
            @if (servicio.cliente.nombre) {
              <span>{{ servicio.cliente.nombre }}</span>
            } @else {
              <span class="no-info">Sin cliente</span>
            }
          </div>
        }
      </div>
    </app-content-card>

    <!-- Conductor y Proveedor -->
    <app-content-card
      title="Conductor y Proveedor"
      icon="account_box"
      color="green"
    >
      <div class="info-grid">
        <div class="info-item">
          <strong>{{ conductorLabel }}</strong>
          <span>{{ nombreUsuario }}</span>
        </div>
        @if (servicio.usuario?.usuario) {
          <div class="info-item">
            <strong>Usuario</strong>
            <span>{{ servicio.usuario.usuario }}</span>
          </div>
        }
        <div class="info-item">
          <strong>Proveedor</strong>
          <span>{{ servicio.proveedor?.nombre || 'Sin proveedor' }}</span>
        </div>
      </div>
    </app-content-card>

    <!-- Registro -->
    <app-content-card title="Registro" icon="ballot" color="orange">
      <div class="info-grid">
        <div class="info-item">
          <strong>Kilometraje</strong>
          @if (servicio.kmDelMantenimiento != null) {
            <span>{{ servicio.kmDelMantenimiento | number: '1.0-0' }} km</span>
          } @else {
            <span class="no-info">Sin kilometraje</span>
          }
        </div>
        @if (esCombustible && servicio.litrosCargados != null) {
          <div class="info-item">
            <strong>Litros cargados</strong>
            <span>{{ servicio.litrosCargados | number: '1.0-2' }} L</span>
          </div>
        }
        <div class="info-item">
          <strong>Costo Total</strong>
          @if (costoTexto) {
            <span>{{ costoTexto }}</span>
          } @else {
            <span class="no-info">Sin costo</span>
          }
        </div>
      </div>
    </app-content-card>

    <!-- Detalles -->
    @if (servicio.detalles) {
      <app-content-card title="Detalles" icon="description" color="purple">
        <p class="detalle-texto">{{ servicio.detalles }}</p>
      </app-content-card>
    }

    <!-- Fotos -->
    @if (servicio.fotos?.length) {
      <app-content-card title="Fotos" icon="photo_library" color="teal">
        <app-carrusel [imagenes]="servicio.fotos" titulo="Fotos"></app-carrusel>
      </app-content-card>
    }
  </mat-card-content>

  <mat-divider></mat-divider>

  <!-- Botones -->
  <mat-card-actions class="actions-create">
    <app-button
      matType="mat-fab extended"
      color="primary"
      (click)="dialogRef?.close()"
      text="Cerrar"
      icon="close"
    ></app-button>
  </mat-card-actions>
</mat-card>
